import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { usePartnerAuth } from '../../contexts/PartnerAuthContext';
import ChangePasswordGate from '../ChangePasswordGate';
import { partnerTheme } from './partnerTheme';

// Guard de rutas /partner/* — patrón CustomerProtectedRoute con la auth partner.

const PartnerProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading, mustChangePassword, changePassword, logout, me } =
    usePartnerAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/partner/login" state={{ from: location }} replace />;
  }

  // Contrato F1: mientras arrastre la contraseña de un solo uso no se pinta
  // ninguna ruta del portal. Mismo gate que el portal cliente, envuelto en el
  // tema partner porque aquí el ThemeProvider lo aplica cada página, no el
  // router — sin esto la pantalla saldría con el tema por defecto.
  if (mustChangePassword) {
    return (
      <ThemeProvider theme={partnerTheme}>
        <ChangePasswordGate
          email={me?.user?.email}
          onSubmit={changePassword}
          onCancel={logout}
        />
      </ThemeProvider>
    );
  }

  return <>{children}</>;
};

export default PartnerProtectedRoute;
